import { useMediaQuery } from "@react-hookz/web"

import { consumeHook } from "@/lib/consume/hook"

const isSmallDeviceQuery = `only screen and (max-width : 639px)`

export const consumeIsSmallDevice = consumeHook({
  getHookArguments: () => {
    return [isSmallDeviceQuery] as Parameters<typeof useMediaQuery>
  },
  hook: useMediaQuery,
  provideTo: `isSmallDevice`,
})
